import { useState } from "react";
import { Link2, Check } from "lucide-react";
import { toast } from "sonner";

// Copies a shareable, unauthenticated deep link to the clipboard. `path` may be
// a relative app path (e.g. "/activities/foo/organizer") or an absolute URL.
export function CopyLinkButton({
  path,
  label = "Copy link",
  testid,
  className = "",
  variant = "solid",
  stopPropagation = false,
}) {
  const [copied, setCopied] = useState(false);

  async function copy(e) {
    if (stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
    const url = /^https?:\/\//i.test(path) ? path : window.location.origin + path;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch {
        /* ignore */
      }
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  }

  const base =
    "inline-flex items-center justify-center gap-1.5 rounded-full font-semibold transition-colors";
  const styles =
    variant === "ghost"
      ? "px-3 py-1.5 text-xs bg-brand-navy/5 text-brand-navy hover:bg-brand-navy/10"
      : variant === "onDark"
      ? "px-3 py-1.5 text-xs bg-white/15 text-white hover:bg-white/25"
      : "px-4 py-2 text-sm border border-brand-navy/15 bg-white text-brand-navy hover:border-brand-orange hover:text-brand-orange";

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={copy}
      className={`${base} ${styles} ${className}`}
    >
      {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      {copied ? "Copied!" : label}
    </button>
  );
}
